export default {
  app: {
    privacy: {
      policy: 'Πολιτική απορρήτου',
      expansive: 'Χρησιμοποιώντας το Expansive, συμφωνείτε με την {action} του Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Η συνεδρία έληξε',
    sessionExpiredDescription:
      'Η συνεδρία σας έχει λήξει. Παρακαλώ συνδεθείτε ξανά για να συνεχίσετε να χρησιμοποιείτε την εφαρμογή.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Επιλέξτε γλώσσα',
      chooseLanguageDescription:
        'Επιλέξτε την προτιμώμενη γλώσσα για την εφαρμογή. Αυτό θα αλλάξει τη γλώσσα της διεπαφής και του περιεχομένου.',
    },
    userSelection: {
      cancel: 'Ακύρωση',
      createNewUser: 'Το όνομά τους δεν εμφανίζεται',
      newUser: 'Νέος χρήστης',
      selectAnExistingUser: 'Επιλέξτε υπάρχοντα χρήστη',
      selectUserHint: 'Επιλέξτε έναν υπάρχοντα χρήστη ή δημιουργήστε έναν νέο για να συνεχίσετε.',
      startTypingToSearch: 'Ξεκινήστε να πληκτρολογείτε...',
    },
    verification: {
      codeVerification: {
        continue: 'Συνέχεια',
        header: 'Εισάγετε τον κωδικό πρόσβασης τοποθεσίας',
        invalidCode: 'Μη έγκυρος κωδικός, παρακαλώ δοκιμάστε ξανά.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Συνέχεια χωρίς επαλήθευση τοποθεσίας',
        enterSiteAccessCode: 'Εισάγετε τον κωδικό πρόσβασης τοποθεσίας',
        locationNotEnabledOrAvailable: 'Γιατί το βλέπω αυτό;',
        notAvailable: {
          description: 'Η τοποθεσία GPS δεν υποστηρίζεται σε αυτήν τη συσκευή.',
          header: 'Η τοποθεσία δεν υποστηρίζεται',
        },
        notEnabled: {
          description: 'Οι υπηρεσίες τοποθεσίας δεν είναι ενεργοποιημένες ή δεν έχει δοθεί άδεια.',
          header: 'Η τοποθεσία δεν είναι ενεργοποιημένη',
        },
        notVerified: {
          description: 'Το GPS δείχνει ότι δεν βρίσκεστε στον χώρο.',
          header: 'Η τοποθεσία δεν επαληθεύτηκε',
        },
        tryAgain: 'Δοκιμάστε ξανά',
        unavailable: {
          description: 'Δεν μπορέσαμε να επαληθεύσουμε την τοποθεσία GPS σας.',
          header: 'Η τοποθεσία δεν είναι διαθέσιμη',
        },
        unknown: {
          description: 'Δεν μπορούμε να προσδιορίσουμε την τοποθεσία σας.',
          header: 'Άγνωστη τοποθεσία',
        },
        verified: {
          description: 'Το GPS δείχνει ότι βρίσκεστε στον χώρο.',
          header: 'Η τοποθεσία επαληθεύτηκε',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Δεν βρέθηκαν περιουσιακά στοιχεία',
        emptyDescription: 'Δεν υπάρχουν περιουσιακά στοιχεία συνδεδεμένα με αυτήν την εργασία.',
        warrantyParts: 'Η εγγύηση των ανταλλακτικών λήγει',
        serialNumber: 'Αριθμός σειράς',
        none: '<κανένα>',
      },
      updates: {
        emptyTitle: 'Δεν βρέθηκαν ενημερώσεις',
        emptyDescription: 'Δεν υπάρχουν ενημερώσεις για αυτήν την εργασία.',
        unknownUser: 'Άγνωστος χρήστης',
        none: 'Καμία',
        addComment: {
          buttonLabel: 'Προσθήκη σχολίου',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Κίνδυνοι',
          no: 'Όχι',
          yes: 'Ναι',
        },
      },
    },
    attachmentsList: {
      attachments: 'Συνημμένα',
      documents: 'Έγγραφα',
      siteDocuments: 'Έγγραφα τοποθεσίας',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Κίνδυνοι',
        induction: 'Εκπαίδευση',
        safeToProceed: 'Ασφαλές για προχωρήσετε',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Ημερομηνία λήξης',
        activeSessions: 'Ενεργές συνεδρίες',
        activeSessionsDescription:
          'Έχετε ήδη ελέγξει στις παρακάτω εργασίες. Πρέπει να αποσυνδεθείτε από αυτές τις εργασίες πριν ελέγξετε σε μια νέα εργασία.',
        resumeSession: 'Συνέχεια',
        startTime: 'Ξεκίνησε στις',
        unexpectedErrorTitle: 'Απρόβλεπτο σφάλμα',
        unexpectedErrorMessage:
          'Παρουσιάστηκε ένα απρόβλεπτο σφάλμα κατά την προσπάθεια δημιουργίας των συνεδριών σας. Παρακαλώ δοκιμάστε ξανά αργότερα.',
        engineerNotFound: 'Μηχανικός δεν βρέθηκε',
        engineerNotFoundDescription:
          'Ο μηχανικός που προσπαθείτε να ελέγξετε δεν βρέθηκε στο σύστημα. Παρακαλώ επικοινωνήστε με τον διαχειριστή σας.',
      },
      verification: {
        code: {
          description:
            'Για να ελέγξετε, παρακαλώ αποκτήστε τον 4-ψήφιο κωδικό από τον υπεύθυνο της τοποθεσίας ή τον καθορισμένο επαφή.',
        },
        geo: {
          continue: 'Συνέχεια',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Παρακαλώ λάβετε τον κωδικό πρόσβασης από τον υπεύθυνο του χώρου ή τον καθορισμένο επαφή για να ολοκληρώσετε την επίσκεψή σας.',
            checkOut: 'Αποσύνδεση',
            completeBeforeLeaving: 'Παρακαλώ συμπληρώστε την παρακάτω φόρμα πριν φύγετε.',
            continue: 'Συνέχεια',
            noResolutionSelected: 'Παρακαλώ επιλέξτε μια λύση πριν συνεχίσετε.',
            quoteRequired: {
              hint: 'Η επίσκεψη ολοκληρώθηκε, η προσφορά θα ακολουθήσει',
              label: 'Απαιτείται προσφορά',
            },
            returnVisitRequired: {
              hint: 'Θα επιστρέψουμε ξανά για να ολοκληρώσουμε',
              label: 'Απαιτείται επιστροφή',
            },
            serviceCompleted: {
              hint: 'Δεν απαιτείται περαιτέρω ενέργεια',
              label: 'Η υπηρεσία ολοκληρώθηκε',
            },
            uploadCheckout: 'Ανεβάστε ένα αρχείο, φωτογραφία ή βίντεο',
            visitNotes: 'Σημειώσεις επίσκεψης',
            workOrderResolution: 'Λύση εργασίας',
            enterNotes: 'Εισάγετε τυχόν σημειώσεις εδώ...',
            errors: {
              timedOut:
                'Λήξη χρονικού ορίου, ξεπεράστηκαν τα 30 δευτερόλεπτα. Παρακαλώ δοκιμάστε ξανά.',
              closingSession: 'Σφάλμα κατά το κλείσιμο της συνεδρίας',
            },
          },
          success: {
            description:
              'Σας ευχαριστούμε που επισκεφθήκατε το {site}. | Το {site} έχει ακόμα 1 ανοιχτή εργασία. | Το {site} έχει ακόμα {count} ανοιχτές εργασίες.',
            endVisit: 'Λήξη επίσκεψης',
            header: 'Έχετε αποσυνδεθεί με επιτυχία',
            viewWorkOrders: 'Ελέγξτε σε άλλη εργασία',
          },
          verification: {
            code: {
              description:
                'Για να αποσυνδεθείτε, παρακαλώ αποκτήστε τον 4-ψήφιο κωδικό από τον υπεύθυνο της τοποθεσίας ή τον καθορισμένο επαφή.',
              continue: 'Συνέχεια',
            },
            geo: {
              checkOut: 'Αποσύνδεση',
              continue: 'Συνέχεια',
            },
          },
        },
        detail: {
          assets: 'Περιουσιακά στοιχεία',
          call: 'Κλήση',
          checkOut: 'Αποσύνδεση',
          closed: 'Κλειστό',
          details: 'Λεπτομέρειες',
          dueBy: 'Ημερομηνία λήξης',
          manageEngineers: 'Διαχείριση μηχανικών',
          notAvailable: 'Μη διαθέσιμο',
          pointOfContact: 'Υπεύθυνος επαφής',
          siteAccessTimes: 'Ώρες πρόσβασης τοποθεσίας',
          siteAccessInstructions: 'Οδηγίες πρόσβασης',
          siteAddress: 'Διεύθυνση τοποθεσίας',
          siteNotes: 'Σημειώσεις τοποθεσίας',
          siteTelephone: 'Τηλέφωνο τοποθεσίας',
          siteLocation: 'Τοποθεσία χώρου',
          updates: 'Ενημερώσεις',
          more: 'Περισσότερα',
          mismatchErrorTitle: 'Σφάλμα εργασίας',
          mismatchErrorMessage:
            'Η εργασία που προσπαθείτε να αποκτήσετε πρόσβαση δεν ταιριάζει με αυτήν που είστε ήδη συνδεδεμένοι. Παρακαλώ ελέγξτε την εργασία σας και δοκιμάστε ξανά.',
          siteDocuments: 'Έγγραφα τοποθεσίας',
          validFrom: 'Έγκυρο από',
          validUntil: 'Έγκυρο έως',
          documentName: 'Όνομα εγγράφου',
          documentType: 'Τύπος εγγράφου',
          attachments: 'Αρχεία εργασίας',
          download: 'Λήψη',
          workDetails: 'Λεπτομέρειες εργασίας',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Προσθήκη βοηθητικού μηχανικού',
            assistantEngineers: 'Βοηθητικοί μηχανικοί',
            description:
              'Για λόγους ασφαλείας, παρακαλώ καθορίστε τα ονόματα κάθε μηχανικού στον χώρο.',
            editMainEngineer: 'Επεξεργασία κύριου μηχανικού',
            errors: {
              creatingEngineer: 'Σφάλμα κατά τη δημιουργία μηχανικού',
              creatingSession: 'Σφάλμα κατά τη δημιουργία συνεδρίας',
            },
            header: 'Μηχανικοί στον χώρο',
            mainEngineer: 'Κύριος μηχανικός',
            newAssistantEngineer: 'Εισάγετε το πλήρες όνομά τους',
            next: 'Επόμενο',
            removeEngineer: 'Αφαίρεση μηχανικού',
            selectExistingAssistantEngineer: 'Αρχίστε να πληκτρολογείτε το όνομά τους',
          },
          index: {
            description:
              'Για λόγους ασφαλείας, παρακαλώ καθορίστε τα ονόματα κάθε μηχανικού στον χώρο.',
            errorCreatingEngineer: 'Σφάλμα κατά τη δημιουργία μηχανικού, παρακαλώ δοκιμάστε ξανά.',
            header: 'Μηχανικοί στον χώρο',
            hintMainEngineer: 'Εισάγετε το πλήρες όνομα του κύριου μηχανικού',
            newMainEngineer: 'Νέος κύριος μηχανικός',
            next: 'Επόμενο',
            selectExistingMainEngineer: 'Επιλέξτε έναν υπάρχοντα κύριο μηχανικό',
            yes: 'Ναι',
            no: 'Όχι',
            mainEngineerLabel: 'Είστε ο κύριος μηχανικός;',
          },
        },
        index: {
          callUsOn: 'Καλέστε μας στο {phoneNumber}',
          description: 'Δεν μπορείτε να βρείτε αυτό που ψάχνετε;',
          dueBy: 'Ημερομηνία λήξης',
          header: 'Επιλέξτε εργασία',
          notAvailable: 'Μη διαθέσιμο',
          searchWorkOrders: 'Αναζητήστε εργασίες...',
        },
        manageEngineers: {
          manageEngineers: 'Διαχείριση μηχανικών',
          notWorking: 'Αδρανείς εργαζόμενοι',
          pause: 'Παύση',
          resume: 'Συνέχεια',
          workingNow: 'Ενεργοί εργαζόμενοι',
          startTime: 'Ώρα έναρξης',
          endTime: 'Ώρα λήξης',
          duration: 'Διάρκεια',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Ανατροφοδότηση',
            feedbackDescription:
              'Παρακαλώ δώστε ανατροφοδότηση σχετικά με την εργασία για να μας βοηθήσετε να βελτιώσουμε τις υπηρεσίες μας.',
            feedbackLabel: 'Ανατροφοδότηση',
            filesLabel: 'Συνημμένα',
            submissionLabel: 'Υποβολή ανατροφοδότησης',
          },
          hazards: {
            back: 'Πίσω',
            hazards: 'Κίνδυνοι',
            next: 'Επόμενο',
            no: 'Όχι',
            noTasksForHazard: 'Δεν υπάρχουν καθήκοντα προς ολοκλήρωση για αυτόν τον κίνδυνο.',
            yes: 'Ναι',
          },
          induction: {
            continue: 'Συνέχεια',
            induction: 'Εκπαίδευση',
          },
          index: {
            checkIn: 'Έλεγχος εισόδου',
            description:
              'Παρακαλώ συμπληρώστε την παρακάτω εκτίμηση κινδύνου για την επιλεγμένη εργασία.',
            fail: 'Αποτυχία επεξεργασίας ελέγχου εργασίας εκκίνησης.',
            haltMessage:
              'Ανιχνεύθηκαν πιθανοί κίνδυνοι. Παρακαλώ σταματήστε την εργασία, ελέγξτε τις οδηγίες ασφαλείας και επικοινωνήστε με τον επόπτη σας για περαιτέρω οδηγίες.',
            header: 'Έλεγχοι πριν την εργασία',
            endVisit: 'Λήξη επίσκεψης',
            leaveFeedback: 'Αφήστε ανατροφοδότηση',
          },
          safeToProceed: {
            continue: 'Συνέχεια',
            safeToProceed: 'Ασφαλές για προχωρήσετε',
          },
        },
      },
    },
    index: {
      title: 'Καλώς ήρθατε',
      description: 'Σαρώστε τον κωδικό QR στην τοποθεσία σας για να ξεκινήσετε.',
    },
    login: {
      errorTitle: 'Απρόβλεπτο σφάλμα',
      errorMessage:
        'Παρουσιάστηκε ένα απρόβλεπτο σφάλμα. Παρακαλώ δοκιμάστε να σαρώσετε ξανά τον κωδικό QR.',
    },
    unauthenticated: {
      welcome: {
        title: 'Καλώς ήρθατε στο {site}',
        description:
          'Πριν μπορέσουμε να σας δείξουμε οποιαδήποτε εργασία, πρέπει να επαληθεύσουμε τα στοιχεία σας. Κάντε κλικ στο κουμπί παρακάτω για να συνεχίσετε.',
        next: 'Συνέχεια',
      },
      index: {
        errorTitle: 'Απρόβλεπτο σφάλμα',
        errorMessage:
          'Παρουσιάστηκε ένα απρόβλεπτο σφάλμα. Παρακαλώ δοκιμάστε να σαρώσετε ξανά τον κωδικό QR.',
      },
      contractor: {
        title: 'Για ποιον εργάζεστε;',
        contractor: 'Ανάδοχος',
        contractorLabel: 'Αρχίστε να πληκτρολογείτε το όνομα της εταιρείας σας',
        contractorHint: 'Πρέπει να εισάγετε 3 χαρακτήρες ή περισσότερους για να δείτε αποτελέσματα',
        defaultSelectPlaceholder: '--Παρακαλώ επιλέξτε--',
        next: 'Επόμενο',
      },
      user: {
        title: 'Ποιος είστε;',
        cancel: 'Ακύρωση',
        createNewUserLabel: 'Το όνομά μου δεν εμφανίζεται',
        existingUserLabel: 'Αρχίστε να πληκτρολογείτε το όνομά σας',
        existingUserHint:
          'Πρέπει να εισάγετε 3 χαρακτήρες ή περισσότερους για να δείτε αποτελέσματα',
        newUserLabel: 'Εισάγετε το πλήρες όνομά σας',
        next: 'Επόμενο',
        user: 'Χρήστης',
      },
      verification: {
        methods: {
          add: {
            add: 'Προσθήκη μεθόδου επαλήθευσης',
            defaultSelectPlaceholder: '--Παρακαλώ επιλέξτε--',
            emailLabel: 'Ηλεκτρονικό ταχυδρομείο',
            existingMethodWarning:
              'Έχετε ήδη μια εκκρεμή αίτηση για αυτήν τη μέθοδο επαλήθευσης που περιμένει έγκριση από τον διαχειριστή. Η προσθήκη μιας νέας θα την αντικαταστήσει.',
            method: 'Μέθοδος',
            methodLabel: 'Μέθοδος',
            mobileCountryHint: 'Παρακαλώ επιλέξτε τον κωδικό χώρας σας',
            mobileCountryLabel: 'Κωδικός χώρας κινητού',
            mobileHint: 'Παρακαλώ εισάγετε τον αριθμό κινητού σας',
            mobileLabel: 'Κινητό',
            title: 'Προσθήκη μεθόδου επαλήθευσης',
          },
          confirm: {
            confirm: 'Επιβεβαίωση',
            description: 'Παρακαλώ επιβεβαιώστε τη μέθοδο επαλήθευσής σας για να συνεχίσετε.',
            label: 'Εισάγετε τον κωδικό σας',
            resend: 'Αποστολή ξανά',
            resendPrompt: 'Δεν λάβατε έναν κωδικό;',
            title: 'Επιβεβαίωση μεθόδου επαλήθευσης',
          },
          confirmed: {
            description:
              'Θα ειδοποιηθείτε μόλις αυτή η μέθοδος επαλήθευσης εγκριθεί από τον διαχειριστή σας, και τότε θα μπορέσετε να την χρησιμοποιήσετε για να επαληθεύσετε την ταυτότητά σας.',
            forceApproval: 'Μέχρι να εγκριθεί, δεν μπορείτε να έχετε πρόσβαση στις εργασίες.',
            nonForceApproval:
              'Εν τω μεταξύ, μπορείτε να συνεχίσετε να έχετε πρόσβαση στις εργασίες με περιορισμένη πρόσβαση.',
            nonForceApprovalButtonLabel: 'Συνεχίστε με περιορισμένη πρόσβαση',
            title: 'Αναμονή έγκρισης',
          },
          addNew: 'Προσθήκη νέας μεθόδου επαλήθευσης',
          description:
            'Πρέπει να επαληθεύσουμε την ταυτότητά σας προκειμένου να σας δώσουμε πλήρη πρόσβαση στην εργασία.',
          email: 'Ηλεκτρονικό ταχυδρομείο',
          hint: 'Θα στείλουμε έναν σύνδεσμο στην επιλεγμένη μέθοδο επαλήθευσης που σας δίνει πλήρη πρόσβαση στην εργασία. Αν χρειάζεται να αλλάξετε οποιαδήποτε υπάρχουσα μέθοδο επαλήθευσης, παρακαλώ επικοινωνήστε με τον διαχειριστή σας.',
          label: 'Επιλέξτε μια μέθοδο επαλήθευσης',
          next: 'Επόμενο',
          pendingHint: 'Αναμονή έγκρισης από τον διαχειριστή σας',
          sms: 'SMS',
          title: 'Επαλήθευση',
        },
        optional: {
          hint: 'Η επαλήθευση των στοιχείων χρήστη θα σας δώσει πλήρη πρόσβαση στην εργασία',
          label: 'Θέλετε να επαληθεύσετε τα στοιχεία χρήστη σας;',
          next: 'Επόμενο',
          no: 'Όχι',
          noHint:
            'Δεν θέλω να επαληθεύσω τα στοιχεία χρήστη μου και να συνεχίσω με περιορισμένη πρόσβαση στην εργασία',
          title: 'Επαλήθευση',
          yes: 'Ναι',
          yesHint:
            'Θέλω να επαληθεύσω τα στοιχεία χρήστη μου και να αποκτήσω πλήρη πρόσβαση στην εργασία',
        },
        sent: {
          description:
            'Ένας σύνδεσμος σύνδεσης έχει σταλεί στο {identifier}. Παρακαλώ κάντε κλικ στον σύνδεσμο για να ολοκληρώσετε τη σύνδεσή σας.',
          title: 'Στάλθηκε σύνδεσμος σύνδεσης',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Χθες',
      today: 'Σήμερα',
      days: {
        monday: 'Δευτέρα',
        tuesday: 'Τρίτη',
        wednesday: 'Τετάρτη',
        thursday: 'Πέμπτη',
        friday: 'Παρασκευή',
        saturday: 'Σάββατο',
        sunday: 'Κυριακή',
      },
      months: {
        january: 'Ιανουάριος',
        february: 'Φεβρουάριος',
        march: 'Μάρτιος',
        april: 'Απρίλιος',
        may: 'Μάιος',
        june: 'Ιούνιος',
        july: 'Ιούλιος',
        august: 'Αύγουστος',
        september: 'Σεπτέμβριος',
        october: 'Οκτώβριος',
        november: 'Νοέμβριος',
        december: 'Δεκέμβριος',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Κάτι πήγε στραβά',
      message: 'Παρακαλώ δοκιμάστε να σαρώσετε ξανά τον κωδικό QR.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Άγνωστος χρήστης',
      },
      none: 'Καμία',
      types: {
        stateTransition: 'Η κατάσταση άλλαξε',
        contractorAssigned: 'Ανάδοχος ανατέθηκε',
        engineerAssigned: 'Μηχανικός ανατέθηκε',
        serviceAssigned: 'Υπηρεσία ανατέθηκε',
        priorityChanged: 'Η προτεραιότητα άλλαξε',
        actionableDateChanged: 'Η ημερομηνία δράσης άλλαξε',
        dueDateChanged: 'Η προθεσμία άλλαξε',
        etaDateChanged: 'Η εκτιμώμενη ημερομηνία άφιξης άλλαξε',
        spendLimitApproved: 'Η έγκριση ορίου δαπανών',
        spendLimitCancelled: 'Η ακύρωση αίτησης ορίου δαπανών',
        spendLimitRejected: 'Η απόρριψη ορίου δαπανών',
        spendLimitRequested: 'Αίτημα ορίου δαπανών',
        jobSheetUploaded: 'Η φόρμα εργασίας ανέβηκε',
        slaAlertSent: 'Ειδοποίηση SLA για χρόνο ανταπόκρισης',
        issuedWorkPermit: 'Εκδόθηκε άδεια εργασίας',
        requestForServiceSent: 'Αίτηση υπηρεσίας στάλθηκε',
        comment: 'Σχόλιο προστέθηκε',
        unknown: 'Άγνωστο γεγονός',
      },
      labels: {
        actionableDate: 'Ημερομηνία δράσης',
        comment: 'Σχόλιο',
        file: 'Αρχείο',
        contractor: 'Ανάδοχος',
        dueDate: 'Προθεσμία',
        etaDate: 'Εκτιμώμενη ημερομηνία άφιξης',
        engineer: 'Μηχανικός',
        priority: 'Προτεραιότητα',
        requestForService: 'Αίτηση υπηρεσίας',
        service: 'Υπηρεσία',
        spendLimit: 'Όριο δαπανών',
        status: 'Κατάσταση',
        workPermit: 'Άδεια εργασίας',
      },
    },
  },
}
